import { persistentAtom } from "@nanostores/persistent";
import { deserialize, serialize } from "wagmi";
import type { TransferTxResult } from "../components/transfers/transfersConfig";
import { LocalStorageKeys } from "./keys";

export const $transferTxHistoryAtom = persistentAtom<TransferTxResult[]>(LocalStorageKeys.TRANSFER_TX_HIST_KEY, [], {
  encode: serialize,
  decode: deserialize,
});

export function getTransferTxHistory(): TransferTxResult[] {
  return $transferTxHistoryAtom.get();
}

export function storeTransferTx(txData: TransferTxResult) {
  const history = $transferTxHistoryAtom.get();
  const data = history.concat(txData);
  $transferTxHistoryAtom.set(data);
}
